export interface Coord {
  row: number;
  col: number;
}

export enum NavigationDirection {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  DOWN = "DOWN",
  UP = "UP",
}

export interface KeyboardNavigationContextValue {
  navigationMap: string[][];
  columnMajor: boolean;
}

export const KeyboardNavigationContextDefaultValue: KeyboardNavigationContextValue =
  { navigationMap: [], columnMajor: false };
